import numberFormat from '@/filters/numberFormat'

export default {
  filters: {
    numberFormat
  },
  props: {
    records: {
      default: () => [],
      required: true,
      type: Array
    },
    summa: {
      default: 0,
      required: true
    }
  }
}
